import { useLocales } from '../../../hooks/locale/useLocales';
import { useCallback } from 'react';
import { taxCountriesIso } from './taxCountries';

export const useGetLocalizedKey = () => {
    const { getLocale } = useLocales();

    const getLocalizedKey = useCallback(
        (key: string, countryOverwrite?: string) => {
            if (!key) {
                return '';
            }

            const baseKey = key.substring(0, key.lastIndexOf('_'));
            const finalKey = `${baseKey}_${countryOverwrite ?? ''}`;

            return getLocale(finalKey);
        },
        [getLocale]
    );

    const getLocalizedSuffix = useCallback((countryCode: string | undefined) => {
        if (!countryCode) {
            return undefined;
        }

        const sanitizedCountryCode = countryCode.includes('-')
            ? countryCode.split('-')[1]?.toUpperCase() || countryCode.toUpperCase()
            : countryCode.toUpperCase();

        if (sanitizedCountryCode === 'DE') {
            return 'DE';
        }

        if (['FR', 'ES', 'CH'].includes(sanitizedCountryCode)) {
            return sanitizedCountryCode;
        }

        if (taxCountriesIso().eu.includes(sanitizedCountryCode)) {
            return 'EU';
        }

        if (taxCountriesIso().nonEU.includes(sanitizedCountryCode)) {
            return 'nonEU';
        }

        return undefined;
    }, []);

    return { getLocalizedKey, getLocalizedSuffix };
};
